import React, { useState, useEffect, useRef, useMemo, useContext } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import TextInput from "components/Input/TextInput.js";
import IntInput from "components/Input/IntInput.js";
import DateInput from "components/Input/DateInput.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import UserService from "services/UserService";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";
import { markets } from "variables/markets";
import { makeStyles } from "@mui/styles";
import { putMarket, getFiles } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import MarketsContext from "context/MarketsContext";
import { NotificationManager } from 'react-notifications';
import Chip from "@mui/material/Chip";
import { statusData, energyData } from "variables/lists/markets";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AddContact from "./AddContact";
import { constrainPoint } from "@fullcalendar/react";
import ContactDialog from "./ContactDialog";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles2 = makeStyles(styles);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
    fontFamily: '"Source Sans Pro",sans-serif',

  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  textInput: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputImage: {
    display: "flex",
    flexDirection: "column",
    margin: "0rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: "12px",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function General(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];

  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;

  //const marketsupdate = permis.includes("markets_update") && market.marketAdminVisibility;
  const marketsupdate = permis.includes("markets_admin") && market.marketAdminVisibility;

  const [name, setName] = useState(market.parameters.general.name);
  const [groups, setGroups] = useState(market.parameters.general.groups);
  const [status, setStatus] = useState(market.parameters.general.status);
  const [datebegin, setDatebegin] = useState(market.parameters.general.datebegin);
  const [dateend, setDateend] = useState(market.parameters.general.dateend);
  const [energy, setEnergy] = useState(market.parameters.general.energy);
  const [marketnumber, setMarketnumber] = useState(market.parameters.general.marketnumber);
  const [associateddocuments, setAssociateddocuments] = useState(market.parameters.general.associateddocuments || []);
  const [otherfiles, setOtherfiles] = useState(market.parameters.general.otherfiles || []);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleGroupsChange = (event) => { setGroups(event.target.value); };
  const handleStatusChange = (event) => { setStatus(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleEnergyChange = (event) => { setEnergy(event.target.value); };
  const handleMarketnumberChange = (event) => { setMarketnumber(event.target.value); };
  const handleOtherfilesChange = (event) => { setOtherfiles(event.target.value); };

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  useEffect(() => {
    axios
      .get(getFiles(chartIdGroup), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  // const selectedDocuments = () => {
  //   let gedCardId = [];
  //   let getGedNames;
  //   if (associateddocuments !== undefined) {
  //     for (let i = 0; i < associateddocuments.length; i++) {
  //       gedCardId.push(associateddocuments[i].fileId);
  //     }
  //     getGedNames = gedList.filter((gedList) =>
  //       gedCardId.includes(gedList.fileId)
  //     );
  //   }
  //   return getGedNames;
  // };
  // const selectedDocuments = () => {
  //   let gedCardId = [];
  //   let getGedNames;
  //   if (associateddocuments !== undefined) {
  //     for (let i = 0; i < associateddocuments.length; i++) {
  //       gedCardId.push(associateddocuments[i].fileId);
  //     }
  //     getGedNames = gedList.filter((gedList) =>
  //       gedCardId.includes(gedList.fileId)
  //     );
  //   }
  //   return getGedNames;
  // };
  const handleAssociateddocumentsChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociateddocuments(newArray);
  };

  const selectedOtherFiles = () => {
    let gedCardId = [];
    let getGedNames;
    if (otherfiles !== undefined) {
      for (let i = 0; i < otherfiles.length; i++) {
        gedCardId.push(otherfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };
  const handleOtherFilesChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setOtherfiles(newArray);
  };

  const handleEdit = () => {
    let editedmarket = { ...market };
    editedmarket.parameters.general = {
      ...editedmarket.parameters.general,
      name,
      status,
      datebegin,
      dateend,
      energy,
      marketnumber,
      associateddocuments,
      otherfiles,
    };
    axios
      .put(
        putMarket(market.id),
        {
          ...editedmarket.parameters
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
          setMarket(editedmarket);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();


  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <TextInput
              inputTitle={markets.general.name}
              textInput={name}
              handleTextInputChange={handleNameChange}
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={markets.general.marketnumber}
              textInput={marketnumber}
              handleTextInputChange={handleMarketnumberChange}
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={markets.general.energy}
              selectValue={energy}
              handleSelectValueChange={handleEnergyChange}
              data={energyData}
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={markets.general.status}
              selectValue={status}
              handleSelectValueChange={handleStatusChange}
              data={statusData}
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <DateInput
              inputTitle={markets.general.datebegin}
              dateInput={datebegin}
              handleDateInputChange={handleDatebeginChange}
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <DateInput
              inputTitle={markets.general.dateend}
              dateInput={dateend}
              handleDateInputChange={handleDateendChange}
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <AutocompleteInput
              disabled={!marketsupdate}
              inputTitle={markets.general.associateddocuments}
              selected={associateddocuments}
              list={gedList}
              handleChange={(_, newValue) =>
                handleAssociateddocumentsChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>
          <div>
            <AutocompleteInput
              disabled={!marketsupdate}
              inputTitle={markets.general.otherfiles}
              selected={otherfiles}
              list={gedList}
              handleChange={(_, newValue) =>
                handleOtherFilesChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {marketsupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Provider(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;

   //const marketsupdate = permis.includes("markets_update") && market.marketAdminVisibility;
  const marketsupdate = permis.includes("markets_admin") && market.marketAdminVisibility;


  const [name, setName] = useState(market.parameters.provider?.name);
  const [inchargename, setInchargename] = useState(market.parameters.provider?.inchargename);
  const [address, setAddress] = useState(market.parameters.provider?.address);
  const [phone, setPhone] = useState(market.parameters.provider?.phone);
  const [email, setEmail] = useState(market.parameters.provider?.email);
  const [requestemail, setRequestemail] = useState(market.parameters.provider?.requestemail);
  const [contacts, setContacts] = useState(market.parameters.provider?.contacts || []);
  const [currentContact, setCurrentContact] = useState(null);
  const [open, setOpen] = useState(false);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleInchargenameChange = (event) => { setInchargename(event.target.value); };
  const handleAddressChange = (event) => { setAddress(event.target.value); };
  const handlePhoneChange = (event) => { setPhone(event.target.value); };
  const handleEmailChange = (event) => { setEmail(event.target.value); };
  const handleRequestemailChange = (event) => { setRequestemail(event.target.value); };


  const classes = useStyles();
  const classes2 = useStyles2();

  const handleEdit = () => {
    let editedmarket = { ...market };
    editedmarket.parameters.provider = {
      ...editedmarket.parameters.provider,
      name,
      contacts,
    };
    axios
      .put(
        putMarket(market.id),
        {
          ...editedmarket.parameters
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
          setMarket(editedmarket);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const columns = [
    {
      name: markets.provider.contactname,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: markets.provider.email,
      selector: (row) => row.email,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.email,
    },
    {
      name: markets.provider.phone,
      selector: (row) => row.phone,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.phone,
    },
    {
      name: markets.provider.address,
      selector: (row) => row.address,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.address,
    },
    {
      name: markets.provider.contactfunction,
      selector: (row) => row.contactfunction,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.contactfunction,
    },
    {
      name: "Actions",
      sortable: false,
      width: "10rem",
      omit: !marketsupdate,
      cell: (row) => (
        <>
          <div className="actions-right">
            <>
              <Tooltip title="Editer le contact">
                <Button
                  onClick={editContact(row)}
                  color={"warning"}
                  className={classes2.actionButton}
                >
                  <EditIcon fontSize="large" />
                </Button>
              </Tooltip>
              <Tooltip title="Supprimer le contact">
                <CustomDeleteButton
                  deleteTitle={"Suppression du contact"}
                  deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le contact ${row.name}?`}
                  handleSupprimer={deleteContactFunction(row)}
                />
              </Tooltip>
            </>
          </div>
        </>
      ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editContact = (row) => async () => {
    let obj = contacts.find((o) => o.uuid === row.uuid);
    if (obj) {
      setCurrentContact(obj);
      handleClickOpen();
    }
  }

  const deleteContactFunction = (row) => async () => {
    const indexToRemove = contacts.findIndex((x) => x.uuid === row.uuid);
    let newcontactlist = [...contacts];
    newcontactlist.splice(indexToRemove, 1);
    console.log(contacts, newcontactlist);
    setContacts(newcontactlist);
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        {marketsupdate ?
          <>
            <UploadButton type="button">
              <AddContact contacts={contacts} setContacts={setContacts} />
            </UploadButton>
          </> : <></>
        }
      </>
    );
  }, [contacts]);

  const customTableStyles = {
    header: {
      style: {
        fontSize: "14px",
        fontFamily: '"Source Sans Pro",sans-serif',
        fontWeight: "600",
      },
    },
  };

  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <TextInput
              inputTitle={markets.provider.name}
              textInput={name}
              handleTextInputChange={handleNameChange}
              disabled={!marketsupdate}
            />
          </div>
          <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
            title="Contacts fournisseur"
            customStyles={customTableStyles}
            noDataComponent={<NoData>Aucun contact à afficher</NoData>}
            // noHeader={true}
            columns={columns}
            persistTableHead
            pagination
            progressComponent={<LinearProgress />}
            expandableRowDisabled={(row) => row.disabled}
            paginationComponentOptions={{
              noRowsPerPage: false,
              rowsPerPageText: "Lignes par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les lignes",
            }}
            defaultPageSize={10}
            data={contacts}
            paginationTotalRows={contacts?.length || 0}
            manual={true}
            paginationResetDefaultPage={0}
            actions={subHeaderComponentMemo}
          />
          <Dialog
            onClose={handleEditClose}
            aria-labelledby="edituser-dialog-title"
            fullWidth="true"
            maxWidth="sm"
            open={open}
          >
            <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
              Modification du contact
            </CustomDialogTitle>
            <DialogContent dividers>
              <ContactDialog
                currentContact={currentContact}
                contacts={contacts}
                setContacts={setContacts}
                closeModal={handleEditClose}
              />
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {marketsupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Marketresponsible(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;
 //const marketsupdate = permis.includes("markets_update") && market.marketAdminVisibility;
  const marketsupdate = permis.includes("markets_admin") && market.marketAdminVisibility;
  
  const [name, setName] = useState(market?.parameters?.marketresponsible?.name);
  const [inchargename, setInchargename] = useState(market?.parameters?.marketresponsible?.inchargename);
  const [address, setAddress] = useState(market?.parameters?.marketresponsible?.address);
  const [phone, setPhone] = useState(market?.parameters?.marketresponsible?.phone);
  const [email, setEmail] = useState(market?.parameters?.marketresponsible?.email);
  const [requestemail, setRequestemail] = useState(market?.parameters?.marketresponsible?.requestemail);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleInchargenameChange = (event) => { setInchargename(event.target.value); };
  const handleAddressChange = (event) => { setAddress(event.target.value); };
  const handlePhoneChange = (event) => { setPhone(event.target.value); };
  const handleEmailChange = (event) => { setEmail(event.target.value); };
  const handleRequestemailChange = (event) => { setRequestemail(event.target.value); };


  const handleEdit = () => {
    let editedmarket = { ...market };
    editedmarket.parameters.marketresponsible = {
      ...editedmarket.parameters.marketresponsible,
      name,
      inchargename,
      address,
      phone,
      email,
      requestemail,
    };
    axios
      .put(
        putMarket(market.id),
        {
          ...editedmarket.parameters
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
          setMarket(editedmarket);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };


  const classes = useStyles();
  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <TextInput
              inputTitle={markets.marketresponsible.name}
              textInput={name}
              handleTextInputChange={handleNameChange}
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={markets.marketresponsible.inchargename}
              textInput={inchargename}
              handleTextInputChange={handleInchargenameChange
              }
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={markets.marketresponsible.address}
              textInput={address}
              handleTextInputChange={handleAddressChange}
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={markets.marketresponsible.phone}
              textInput={phone}
              handleTextInputChange={handlePhoneChange}
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={markets.marketresponsible.email}
              textInput={email}
              handleTextInputChange={handleEmailChange}
              disabled={!marketsupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={markets.marketresponsible.requestemail}
              textInput={requestemail}
              handleTextInputChange={handleRequestemailChange}
              disabled={!marketsupdate}
            />
          </div>

        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {marketsupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

export { General, Provider, Marketresponsible };
